export default "__VITE_ASSET__D1GbTOK6__"